module.exports = __webpack_public_path__ + "img/total-sales.0dc01987.svg";